import script from "./AuthorizationRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorizationRequest.vue?vue&type=script&setup=true&lang=js"

import "./AuthorizationRequest.vue?vue&type=style&index=0&id=2b94dbb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b94dbb4"]])

export default __exports__